// Service data — the 6 dedicated SEO pages at /services/:slug.
// Every service explicitly targets "Sunshine Coast" in metaTitle, metaDesc, h1
// and intro copy to grow organic Google visibility locally.

const SUBURB_MENTIONS = [
  "Maroochydore", "Mooloolaba", "Caloundra", "Noosa", "Buderim",
  "Kunda Park", "Nambour", "Sippy Downs", "Coolum", "Mount Coolum",
  "Yaroomba", "Peregian", "Kawana", "Bli Bli", "Palmwoods",
  "Yandina", "Eumundi", "Tewantin", "Beerwah", "Landsborough",
];

export const SERVICES = [
  {
    slug: "auto-electrician-sunshine-coast",
    name: "Auto Electrician Sunshine Coast",
    h1: "Auto Electrician Sunshine Coast",
    kicker: "Diagnostics, repairs & installs — Kunda Park workshop",
    metaTitle: "Auto Electrician Sunshine Coast | Diagnostics, Repairs & Installs | Powerz Auto Electrical Kunda Park",
    metaDesc: "Trusted auto electrician on the Sunshine Coast — diagnostics, wiring repairs, dual battery installs, A/C service and 4WD electrical work. Powerz Auto Electrical, workshop at Kunda Park for customers from Maroochydore, Caloundra, Noosa, Buderim and every Sunshine Coast suburb. 95+ five-star Google reviews.",
    image: "/gallery/sunshine-coast-auto-electrical-workshop.jpg",
    relatedReviewService: ["Auto Electrical", "12V / Wiring", "Auto Air Conditioning"],
    relatedShop: null,
    relatedServices: [
      "auto-air-conditioning",
      "4x4-auto-electrical-sunshine-coast",
      "towing-electrics-sunshine-coast",
    ],
    relatedBlogs: [
      "what-does-auto-electrical-diagnostic-involve",
      "why-is-my-cars-electrical-system-failing",
      "why-wont-my-car-start-electrical-checklist",
    ],
    priceFrom: "$165/hr",
    intro: [
      "Looking for a reliable, straight-talking auto electrician on the Sunshine Coast? Powerz Auto Electrical is a specialist auto electrical workshop based at Kunda Park, for customers from every Sunshine Coast suburb — Maroochydore, Caloundra, Noosa, Buderim, Mooloolaba, Coolum, Nambour, Sippy Downs, Kawana, Bli Bli, Palmwoods, Yandina, Eumundi, Tewantin, Beerwah, Landsborough and everywhere between. With 10+ years experience at the bench and 95+ five-star Google reviews, we're the shop Sunshine Coast locals send their mates to when something electrical isn't right.",
      "Auto electrics is a specialised trade — separate from mechanical work — and it needs the right tools, the right wiring diagrams and years of hands-on diagnostic experience. Whether it's a warning light on the dash, a no-start, an intermittent electrical gremlin, an under-bonnet dual battery install, a REDARC Tow-Pro brake controller, or an accessory install like driving lights or a UHF — we diagnose the root cause first, quote clearly, then fix it right the first time. No parts-cannon guesswork, no surprise invoices.",
    ],
    whatsIncluded: [
      "Full auto electrical diagnostics — scan tools, multimeters, oscilloscopes and proper wiring diagrams",
      "No-start diagnostics — starter motors, alternators, battery health under load",
      "Warning-light and fault-code investigation — ECU, BCM, ABS, SRS, TCM and body modules",
      "Wiring repairs — burnt harnesses, corroded connectors, water-damaged looms",
      "Dual battery, DC-DC and under-bonnet AGM install work (see our dedicated Under-Bonnet Dual Battery page)",
      "REDARC Tow-Pro Elite brake controller installs (dedicated REDARC page)",
      "12 pin, 7 pin and Anderson plug installs for towing (dedicated Towing page)",
      "Auto air conditioning — ARC-licensed A/C Service from $154 (dedicated A/C page)",
      "Accessory installs — driving lights, light bars, spotlights, UHFs, dashcams, reverse cameras, beacons, underglow",
      "12-month workmanship warranty on every job",
    ],
    whyUs: [
      "10+ years of Sunshine Coast auto electrical experience — registered company, ARC-licensed workshop",
      "95+ genuine five-star Google reviews from Sunshine Coast customers",
      "Straight-talking diagnostics — we identify the fault before we throw parts at it",
      "Transparent workshop rate: $165/hr GST inc, 1-hour minimum, no hidden fees",
      "ARC-licensed for auto air conditioning refrigerant work",
      "Central Kunda Park location — 5 minutes from the Bruce Highway, easy from every Sunshine Coast suburb",
      "12-month workmanship warranty on every install and repair",
    ],
    pricing: {
      label: "Workshop Rates (GST included)",
      items: [
        { name: "Standard workshop rate", price: "$165/hr" },
        { name: "Minimum charge per job", price: "1 hour" },
        { name: "A/C Service (starting price)", price: "From $154" },
      ],
      note: "Larger jobs (under-bonnet dual battery installs, brake controllers, accessory installs) are quoted in writing up-front. See the dedicated service pages for fixed pricing on 12 pin plugs, Anderson plugs, Tow-Pro installs, underglow kits and A/C.",
    },
    process: [
      { title: "Call or email", body: "Tell us what's going on with the vehicle. We'll ask a few diagnostic questions and let you know if it's something we can help with. If we're not the right shop for a specific vehicle we'll tell you up-front and point you somewhere better." },
      { title: "Book in at Kunda Park", body: "Drop the vehicle at our Kunda Park workshop. Most electrical diagnostics take 1-2 hours; larger install jobs are booked into a dedicated workshop slot." },
      { title: "Diagnose, quote, repair", body: "We diagnose the root cause first, contact you with a written quote for the repair, then get it done. No work beyond the quote without your say-so." },
    ],
    faq: [
      {
        q: "Are you a fully qualified Sunshine Coast auto electrician?",
        a: "Yes — Powerz Auto Electrical is a registered Australian company (Pty Ltd) and specialist auto electrical workshop with 10+ years of hands-on experience. We hold the ARC (Australian Refrigeration Council) licence required for automotive air conditioning refrigerant work, and every install carries a 12-month workmanship warranty.",
      },
      {
        q: "Which Sunshine Coast suburbs do you service?",
        a: "All of them. Maroochydore, Mooloolaba, Caloundra, Noosa, Buderim, Kunda Park, Nambour, Sippy Downs, Coolum, Mount Coolum, Yaroomba, Peregian, Kawana, Bli Bli, Palmwoods, Yandina, Eumundi, Tewantin, Beerwah and Landsborough. The workshop is at 2a/3 Hitech Dr, Kunda Park.",
      },
      {
        q: "What's the workshop rate?",
        a: "$165 per hour GST included, with a 1-hour minimum charge on all jobs. Fixed-price jobs (12 pin plug install, Tow-Pro install, A/C service, underglow kits, beacon installs, Anderson plug installs) are quoted up-front — see the dedicated service pages for those prices.",
      },
      {
        q: "Do you work on caravans or camper vans?",
        a: "No. Powerz Auto Electrical works on Vehicles only — 4WDs, utes, sedans, trucks and machinery. Our work on any tow vehicle stops at the trailer plug or Anderson plug. Caravan-side and camper-van-side wiring must be carried out by a dedicated caravan / camper-van electrical specialist. See our Workshop Policies page for the full policy.",
      },
      {
        q: "Do you take on European vehicles like BMW, Audi, Mercedes, VW?",
        a: "Straightforward Euro jobs — yes, we can usually help. Complex factory-system Euro work (deep CAN-bus faults, dealer-tool coding) we often refer to a Euro specialist who'll do you a better job. Give us a call to chat about your specific vehicle.",
      },
      {
        q: "Can you help with a no-start?",
        a: "Yes — no-starts are one of our regular jobs. Battery, starter motor, alternator, ignition switch, immobiliser, fuel or sensor faults — we work through the diagnostic checklist systematically. See our blog post \"Why Won't My Car Start?\" for the full walkthrough.",
      },
    ],
  },

  {
    slug: "underglow-installations-sunshine-coast",
    name: "Underglow Installations Sunshine Coast",
    h1: "Underglow Installations Sunshine Coast",
    kicker: "Full RGB underbody LED kits — $850 supply & install",
    metaTitle: "Underglow Installations Sunshine Coast | Full Kit $850 | Powerz Auto Electrical",
    metaDesc: "Professional underglow installations on the Sunshine Coast — full RGB underbody LED kit supply and install at $850 GST inc. Multi-colour, app or remote control, waterproof, hard-wired with hidden switch. Workshop at Kunda Park for customers from Maroochydore, Caloundra, Noosa, Buderim and every Sunshine Coast suburb.",
    image: "/gallery/underglow-kit-install-bmw-m3-powerz-auto-electrical-sunshine-coast.webp",
    relatedReviewService: ["12V / Wiring", "Auto Electrical"],
    relatedShop: null,
    relatedServices: [
      "auto-electrician-sunshine-coast",
      "driving-lights-spotlights-installation-sunshine-coast",
    ],
    relatedBlogs: [
      "what-tools-do-auto-electricians-use",
      "what-does-auto-electrical-diagnostic-involve",
    ],
    priceFrom: "$850",
    intro: [
      "Underglow installations transform the look of your car — and when done properly, they're a completely legal off-road / show-display upgrade. Powerz Auto Electrical is the Sunshine Coast's specialist workshop for underglow installations, based at Kunda Park and for customers from every Sunshine Coast suburb — Maroochydore, Caloundra, Noosa, Buderim, Mooloolaba, Coolum, Nambour, Sippy Downs, Kawana and everywhere between.",
      "Our full underglow kit at $850 GST inc covers everything — 4-strip RGB LED kit mounted to all four sides of the vehicle, hard-wired with a properly-fused feed, hidden switch, and app or remote control so you can change colours, patterns and brightness on the fly. Every install is clean-loomed, waterproof-rated and dust-sealed. No zip-ties, no scotch-locks, no cigarette-lighter power robbery — proper install, done to Australian auto electrical standards.",
    ],
    whatsIncluded: [
      "Full 4-strip RGB underglow kit — front, rear and both sides of the vehicle",
      "Hard-wired 12V feed with proper fuse and ANL / blade circuit protection",
      "Bluetooth app + remote control included (multi-colour, patterns, brightness, sound-reactive modes)",
      "Discreet hidden switch installed behind the dash or in a factory switch position",
      "Waterproof / dust-sealed strips rated for road use",
      "Clean loom routing along chassis rails and body seams — no strips visible on plain view",
      "12-month workmanship warranty on the install (LED strips carry their own manufacturer warranty)",
      "Optional upgrade to premium RGB IC strips (individually addressable) available on request",
    ],
    whyUs: [
      "Sunshine Coast's specialist underglow installer — done properly, not just cable-tied on",
      "Full kit at a flat $850 GST inc — no surprise labour on the invoice",
      "Waterproof rated strips, sealed connectors — designed to survive Queensland weather",
      "App and remote control included in the base price",
      "Clean, hidden switch install — looks factory, not aftermarket",
      "12-month workmanship warranty",
    ],
    pricing: {
      label: "Underglow Installation Pricing (GST included)",
      items: [
        { name: "Full underglow kit — supply & install", price: "$850" },
        { name: "Upgrade to RGB IC (addressable) strips", price: "Quoted on request" },
      ],
      note: "Pricing is for supply and install at our Kunda Park workshop. Vehicles with complex undercarriage geometry (some sports cars, low-clearance vehicles) may need additional install time — we'll always quote up-front before booking. Underglow is intended for off-road / show display use; use of colours other than white or amber while a vehicle is on a public road is not permitted in Queensland.",
    },
    process: [
      { title: "Confirm vehicle & kit", body: "Send us your vehicle make and model. We'll confirm strip lengths, mounting points and app compatibility, and lock in a workshop slot." },
      { title: "Workshop install", body: "Drop the vehicle to our Kunda Park workshop — most underglow installs are done same-day in 3-4 hours. All four strips mounted, wired, fused and app-paired before you drive away." },
      { title: "Colour walkthrough & handover", body: "We pair the app on your phone, walk you through the colour, pattern and brightness modes, and hand back a fully working kit with the workmanship warranty in writing." },
    ],
    faq: [
      {
        q: "Is underglow legal on the Sunshine Coast / in Queensland?",
        a: "In Queensland, coloured underglow can be used on private property, at car shows and for off-road display purposes. On public roads, only white or amber light is permitted (and cannot flash or resemble emergency-vehicle lighting). We always advise switching underglow OFF while driving on public roads, and we install with a discreet driver-accessible switch specifically so you can do that easily.",
      },
      {
        q: "What colours can I choose from?",
        a: "The standard kit supports the full RGB colour spectrum — millions of colours — plus 20+ preset patterns (fade, strobe, chase, sound-reactive to music, etc.). All controlled via a phone app or included remote.",
      },
      {
        q: "Will the underglow drain my battery?",
        a: "Full RGB draw at maximum brightness is typically 5-8 amps for a full 4-strip kit. On a healthy battery with the engine running, no issue. Left on with the engine off it will draw the battery down after a few hours — which is why we install with a discreet switch on the dash so you can isolate power completely.",
      },
      {
        q: "How long does an underglow install take?",
        a: "Most vehicles are 3-4 hours at our Kunda Park workshop. Sports cars with low clearance or complex undercarriage geometry can take longer — we'll always quote the specific time up-front.",
      },
      {
        q: "Do you install underglow on any vehicle?",
        a: "Yes — cars, 4WDs, utes, project builds, show cars. As long as we can find safe mounting points along the chassis or body seams, we can install a full kit. Motorbikes are outside our scope for underglow work.",
      },
      {
        q: "Which Sunshine Coast suburbs do you service for underglow installations?",
        a: "All of them. Maroochydore, Mooloolaba, Caloundra, Noosa, Buderim, Kunda Park, Nambour, Sippy Downs, Coolum, Mount Coolum, Yaroomba, Peregian, Kawana, Bli Bli, Palmwoods, Yandina, Eumundi, Tewantin, Beerwah and Landsborough. Every underglow install is done at our Kunda Park workshop.",
      },
    ],
  },

  {
    slug: "12-pin-trailer-plug-install",
    name: "12 Pin Trailer Plug Install Sunshine Coast",
    h1: "12 Pin Trailer Plug Install Sunshine Coast",
    kicker: "Tow-vehicle install — for trailers, boats & towed campers",
    metaTitle: "12 Pin Trailer Plug Install Sunshine Coast | From $495 | Powerz Auto Electrical",
    metaDesc: "Professional 12 pin trailer plug install on the Sunshine Coast from $495 GST inc. Customers come to us from Maroochydore, Caloundra, Noosa, Buderim and all Sunshine Coast suburbs. Same-day install at our Kunda Park workshop.",
    image: "/pricing/12pin-with-sensors.jpg",
    relatedReviewService: ["Towing Electrics"],
    relatedShop: "towing-electrics",
    priceFrom: "$495",
    intro: [
      "Towing a caravan, camper trailer or box trailer on the Sunshine Coast? A properly wired 12 pin trailer plug is the difference between a smooth tow and a dangerous one. At Powerz Auto Electrical we install 12 pin flat trailer plugs to Australian standards with quality components, dedicated relays and a 12-month workmanship warranty — out of our Kunda Park workshop, for customers from Maroochydore, Caloundra, Noosa, Buderim, Mooloolaba, Coolum, Nambour, Sippy Downs and every Sunshine Coast suburb.",
      "A 12 pin plug carries everything your trailer needs from the tow vehicle — running lights, brake lights, indicators, reverse, brake controller signal and a dedicated 12V auxiliary line for fridges, charging or interior accessories. Done right by a Sunshine Coast auto electrician, it just works. Done poorly with cheap parts and lazy wiring, it'll cook a fuse, melt a connector or back-feed signals into your tow vehicle's CAN-bus — none of which you want 200km out of town.",
    ],
    whatsIncluded: [
      "Quality 12 pin flat plug (industry-standard Narva or equivalent) hard-wired to your tow bar",
      "Dedicated relay-controlled auxiliary circuit (so your fridge / charge line doesn't draw from the start battery while engine is off)",
      "Proper fuse and circuit protection sized to your alternator and accessory load",
      "Heat-shrink terminations on every connection — no scotch-locks, no twist-and-tape",
      "Cable run protected, loomed and clipped to the chassis — not zip-tied to brake lines",
      "Optional reverse-sensor disable so your factory parking sensors mute when the trailer is connected",
      "Function test on all 12 pins with our trailer simulator before you leave the workshop",
    ],
    whyUs: [
      "Sunshine Coast workshop — most 12 pin installs done same day if booked ahead",
      "12-month workmanship warranty on every install",
      "Compliant with Australian Design Rules and trailer-wiring standards",
      "Optional sensor-disable kit available for late-model vehicles with parking sensors",
      "Genuine Narva, Hella and REDARC parts — no cheap eBay imports",
    ],
    pricing: {
      label: "Pricing (GST included)",
      items: [
        { name: "12 Pin Plug — Basic, Without Reverse Sensors, With Relay", price: "$495" },
        { name: "12 Pin Plug — With Reverse Sensors & Relay", price: "$530" },
      ],
      note: "Price shown is for a basic 12 pin plug install. Additional charges may apply if extra pins or circuits are required. Pricing is for supply and install at our Kunda Park workshop. Vehicles requiring specialist diode kits or extension harnesses (some late-model CAN-bus vehicles) may attract an additional charge — we'll always quote up-front.",
    },
    policy: {
      title: "Important — Caravan Wiring Diagram Required",
      bullets: [
        "Customers must supply a current wiring diagram for the caravan, camper trailer or trailer before any 12 pin install can be booked in. No diagram = no booking — we won't guess at how a third party has wired the van.",
        "Powerz Auto Electrical does NOT work on caravans or the wiring inside a caravan. Our work stops at the plug on the tow vehicle. Any caravan-side wiring must be carried out by a caravan electrical specialist.",
        "Powerz Auto Electrical accepts no responsibility for the condition of the caravan, its internal wiring, charging system, fuses, appliances or any pre-existing faults discovered during or after the install.",
      ],
    },
    process: [
      { title: "Book in", body: "Call 0428 182 015 or send a quick enquiry. We'll confirm fitment and book you a workshop slot at our Kunda Park workshop — usually within the week." },
      { title: "Drop off", body: "Bring the vehicle to our Sunshine Coast workshop at Kunda Park. Most jobs are done same-day in 2-3 hours." },
      { title: "Test & drive away", body: "We function-test the plug with our trailer simulator before you leave, so you know every pin works." },
    ],
    faq: [
      {
        q: "Do I need a wiring diagram of my caravan before booking in?",
        a: "Yes — it's mandatory. Every 12 pin install requires the customer to supply a current wiring diagram for the caravan, camper trailer or trailer. We need to know exactly how the van is wired before we wire the vehicle-side plug. No diagram = no booking. This protects both you and us from miswiring a fridge circuit, brake feed, or charge line into the wrong pin.",
      },
      {
        q: "Do you do the wiring inside the caravan too?",
        a: "No. Powerz Auto Electrical does NOT work on caravans. Our work stops at the trailer plug on the tow vehicle. Any caravan-side wiring, repairs, faults or modifications must be carried out by a dedicated caravan electrical specialist. We also accept no responsibility for the condition of the caravan, its internal wiring or any pre-existing faults.",
      },
      {
        q: "How long does a 12 pin trailer plug install take on the Sunshine Coast?",
        a: "Most 12 pin installs are done same-day in 2-3 hours at our Kunda Park workshop. Late-model vehicles needing a diode kit or extension harness may take a little longer but we'll let you know up-front.",
      },
      {
        q: "Do I need reverse-sensor disable on a 12 pin install?",
        a: "If your vehicle has factory parking sensors, yes — without disable, your sensors will trigger on the trailer drawbar and beep constantly while reversing. Our $530 12 pin install includes the sensor-disable relay.",
      },
      {
        q: "Which Sunshine Coast suburbs do you service for 12 pin installs?",
        a: "All of them. Maroochydore, Mooloolaba, Caloundra, Noosa, Buderim, Kunda Park, Nambour, Sippy Downs, Coolum, Mount Coolum, Yaroomba, Peregian, Kawana, Bli Bli, Palmwoods, Yandina, Eumundi, Tewantin, Beerwah and Landsborough.",
      },
      {
        q: "Can you also install an Anderson plug at the same time?",
        a: "Yes — Anderson plug installs are typically done at the same time as 12 pin work. Grey Anderson no-relay $495, grey Anderson with relay $550 (GST inc). A wiring diagram for the caravan is required for Red Anderson installs (same policy as the 12 pin).",
      },
    ],
  },

  {
    slug: "redarc-brake-controllers",
    name: "REDARC Brake Controllers Sunshine Coast",
    h1: "REDARC Tow-Pro Elite Brake Controller Install Sunshine Coast",
    kicker: "REDARC Tow-Pro installations — Sunshine Coast",
    metaTitle: "REDARC Brake Controllers Sunshine Coast | Tow-Pro Elite Install from $805 | Powerz",
    metaDesc: "REDARC Tow-Pro Elite brake controller supply & install on the Sunshine Coast. Basic install from $805, Smart install from $855, Amarok & Next-Gen Ranger / Everest $1,080.38 — GST included. Workshop at Kunda Park. REDARC Tow-Pro installations for customers from Maroochydore, Caloundra, Noosa, Buderim.",
    image: "/pricing/towpro-basic.jpg",
    relatedReviewService: ["Towing Electrics"],
    relatedShop: "towing-electrics",
    relatedServices: [
      "towing-electrics-sunshine-coast",
      "12-pin-trailer-plug-install",
      "anderson-plug-installation-sunshine-coast",
      "caravan-tow-vehicle-electrical-sunshine-coast",
    ],
    relatedBlogs: [
      "300-series-landcruiser-tow-pro-install",
      "what-brake-controller-do-i-need",
      "why-is-my-cars-electrical-system-failing",
      "why-wont-my-car-start-electrical-checklist",
    ],
    priceFrom: "$805",
    intro: [
      "The REDARC Tow-Pro Elite is Australia's most trusted electric trailer brake controller — and Powerz Auto Electrical is one of the Sunshine Coast's specialist installers. Whether you're towing a 1.5-tonne box trailer or a 3-tonne caravan, the Tow-Pro Elite gives you proportional, smooth, factory-grade trailer braking from a discreet dashboard switch.",
      "We supply and install the Tow-Pro Elite at our Kunda Park workshop for Sunshine Coast customers across Maroochydore, Caloundra, Noosa, Buderim, Mooloolaba, Coolum, Nambour, Sippy Downs and every suburb between. Every install is to REDARC's manufacturer-spec wiring, with proper fuses, harnesses and dash switch placement.",
    ],
    whatsIncluded: [
      "Genuine REDARC Tow-Pro Elite EBRH-ACCV3 unit (covers ESC-equipped vehicles)",
      "Vehicle-specific wiring harness — no splice-and-tape rubbish",
      "Discreet REDARC dash switch blank fitted into a factory switch position where available",
      "Tow-Pro mounted out of sight under the dash with proper anchoring",
      "Full activation and calibration drive after install — you don't leave until it brakes properly",
      "12-month workmanship warranty (Tow-Pro itself has REDARC's manufacturer warranty)",
    ],
    whyUs: [
      "Specialist Tow-Pro installer — done dozens, not just a couple",
      "Three install tiers transparently priced — Basic ($805), Smart ($855), and Amarok / Next-Gen Ranger & Everest ($1,080.38)",
      "REDARC Tow-Pro & BCDC installations — Tow-Pro, BCDC, SBI-12 and Manager supply & install",
      "Sunshine Coast workshop at Kunda Park — central to Maroochydore, Caloundra, Noosa and Buderim",
    ],
    pricing: {
      label: "Tow-Pro Elite Install Pricing (GST included)",
      items: [
        { name: "Tow-Pro Elite — Basic Install (plug-and-play vehicles)", price: "$805" },
        { name: "Tow-Pro Elite — Smart Install (CAN-bus / late-model vehicles)", price: "$855" },
        { name: "Tow-Pro Elite — Amarok & Next-Gen Ranger / Everest", price: "$1,080.38" },
      ],
      note: "Basic install covers most vehicles up to ~2020. Smart install is required for late-model CAN-bus vehicles such as Prado J250, LandCruiser 300, D-MAX 3rd Gen, MU-X 2nd Gen, Triton 6th Gen, Y62 Patrol, Navara D27 and BT-50 3rd Gen. VW Amarok (both gens) and Ford Next-Gen Ranger / Everest 3rd Gen are quoted separately at $1,080.38 because they require a vehicle-specific harness and additional diagnostic time.",
    },
    process: [
      { title: "Confirm vehicle", body: "Tell us your make, model and year and we'll confirm whether you fall under Basic, Smart, or the Amarok / Next-Gen Ranger & Everest install pricing." },
      { title: "Workshop booking", body: "Most installs are done in a single Kunda Park workshop visit, typically 3-4 hours." },
      { title: "Calibration drive", body: "After install we test-drive with a trailer to dial in the Tow-Pro for your vehicle and trailer combo." },
    ],
    faq: [
      {
        q: "Do I need a Tow-Pro Basic, Smart or Amarok / Next-Gen install for my vehicle?",
        a: "If your vehicle is older than ~2020 (Hilux pre-AN130, Prado pre-J250, LandCruiser 200 etc.), it's a Basic install at $805. If you've got a recent CAN-bus vehicle (Prado J250, LC 300, D-MAX 3rd Gen, MU-X 2nd Gen, Triton 6th Gen, Y62 Patrol, Navara D27, BT-50 3rd Gen), it's the Smart install at $855. VW Amarok (both gens) and the Ford Next-Gen Ranger / Everest 3rd Gen are priced separately at $1,080.38 because they require a vehicle-specific harness and additional diagnostic time. Not sure which yours is? Send us your rego — we'll confirm in writing before you book in.",
      },
      {
        q: "How long does a Tow-Pro Elite install take?",
        a: "Around 3-4 hours including calibration. We book one Tow-Pro install per workshop slot so the job gets full attention.",
      },
      {
        q: "Where is the Tow-Pro switch mounted?",
        a: "Wherever your dash will accommodate it cleanly — we use a REDARC dash blank that fits a factory switch position on most vehicles, so it looks OEM, not aftermarket.",
      },
      {
        q: "Is the Tow-Pro install done at your Sunshine Coast workshop?",
        a: "Yes — all Tow-Pro installs are done at our workshop at 2a/3 Hitech Dr, Kunda Park. They need a controlled environment and a test trailer for calibration, so we don't do them anywhere else.",
      },
    ],
  },

  {
    slug: "dual-battery-systems",
    name: "Under-Bonnet Dual Battery Sunshine Coast",
    h1: "Under-Bonnet Dual Battery Systems Sunshine Coast",
    kicker: "AGM auxiliaries — factory tray location",
    metaTitle: "Under-Bonnet Dual Battery Sunshine Coast | AGM + DC-DC Install | Powerz Auto Electrical",
    metaDesc: "Under-bonnet dual battery installs on the Sunshine Coast — AGM auxiliary batteries in the factory tray location, REDARC BCDC DC-DC charging, hidden clean wiring. No boot batteries, no lost storage. Powerz Auto Electrical, Kunda Park workshop for customers from Maroochydore, Caloundra, Noosa and Buderim.",
    image: "/gallery/4wd-dual-battery-fitout-sunshine-coast.jpg",
    relatedReviewService: ["Dual Battery"],
    relatedShop: null,
    relatedServices: [
      "redarc-bcdc-installation-sunshine-coast",
      "4x4-auto-electrical-sunshine-coast",
      "anderson-plug-installation-sunshine-coast",
    ],
    relatedBlogs: [
      "what-size-bcdc-charger-do-i-need",
      "why-wont-my-car-start-electrical-checklist",
      "what-causes-most-automotive-electrical-failures",
    ],
    priceFrom: "POA",
    intro: [
      "Powerz Auto Electrical specialises in under-bonnet dual battery installs for customers from across the Sunshine Coast. An AGM auxiliary battery mounted in the factory tray location under the bonnet, paired with a REDARC BCDC DC-DC charger — clean, hidden, no boot batteries, no lost storage space, no dodgy behind-seat installs. Just proper vehicle-side power for accessories like fridges, lights, UHFs and camera systems.",
      "We're based in Kunda Park, for customers from Maroochydore, Caloundra, Noosa, Buderim, Mooloolaba, Coolum, Nambour, Sippy Downs and every Sunshine Coast suburb between. This is our specialty — under-bonnet dual battery, done properly to REDARC's manufacturer wiring spec, with a 12-month workmanship warranty. Note: we do NOT do off-grid setups, behind-seat dual battery, lithium house-banks or full touring fitouts. We do NOT work on caravans or camper vans.",
    ],
    whatsIncluded: [
      "AGM auxiliary battery mounted in the factory under-bonnet tray location (or purpose-built bracket where required)",
      "REDARC BCDC DC-DC charger — sized to your alternator's spare capacity",
      "Anderson outputs for accessory power (driving lights, fridge, UHF etc.)",
      "Properly-sized ANL fusing on every battery terminal and circuit",
      "Heat-shrink terminations, loomed cable runs — factory-look finish",
      "Optional battery monitor (REDARC Manager, Victron BMV or similar) if requested",
      "Full function-test under load before you drive away",
      "12-month Powerz workmanship warranty + REDARC's own manufacturer warranty",
    ],
    whyUs: [
      "Under-bonnet specialists — factory location, hidden wiring, no lost storage space",
      "Supply & install of REDARC BCDC DC-DC chargers",
      "Neat, fused, labelled wiring — the kind of install you can show your mates",
      "12-month workmanship warranty on every install",
      "Sunshine Coast local — workshop at Kunda Park, servicing all suburbs",
    ],
    pricing: {
      label: "Pricing",
      items: [
        { name: "Under-bonnet dual battery — consultation", price: "Free with quote" },
        { name: "AGM under-bonnet dual battery install", price: "From ~$1,200" },
      ],
      note: "Final pricing depends on battery size, DC-DC charger spec and accessory wiring. We give a full written quote before any work starts. We do NOT install behind-seat or off-grid setups.",
    },
    policy: {
      title: "Important — Caravan Wiring Diagram Required for Red Anderson Installs",
      bullets: [
        "If your dual battery install includes a Red Anderson plug intended to connect to a caravan, you must supply a current wiring diagram for the caravan before the job is booked in. No diagram = no booking.",
        "Powerz Auto Electrical does NOT work on caravans or the wiring inside a caravan. Our work stops at the plug on the tow vehicle. Caravan-side wiring must be carried out by a dedicated caravan electrical specialist.",
        "Powerz Auto Electrical accepts no responsibility for the condition of the caravan, its internal wiring, charging system, fuses, appliances or any pre-existing faults discovered during or after the install.",
      ],
    },
    process: [
      { title: "Consult & spec", body: "We confirm your vehicle model, verify factory-tray fitment, and spec the right AGM battery size and REDARC BCDC DC-DC charger for your accessories." },
      { title: "Workshop install", body: "Battery, DC-DC charger and accessory wiring installed at our Kunda Park workshop. Typical install: 1 workshop day." },
      { title: "Test & handover", body: "Full system test under load, and a quick walkthrough so you know exactly how the install works." },
    ],
    faq: [
      {
        q: "Do you do behind-seat or boot-mounted dual battery installs?",
        a: "No. Our specialty is under-bonnet dual battery only — AGM auxiliary batteries mounted in the factory tray location under the bonnet. We don't do behind-seat, tub-mounted, boot-mounted or drawer-integrated dual battery installs.",
      },
      {
        q: "Do you install lithium batteries or full off-grid setups?",
        a: "No. We're an auto electrical workshop specialising in under-bonnet AGM dual battery only. We do NOT install lithium house-banks, off-grid setups, solar systems, MPPT regulators, inverters or full touring fitouts. For those kinds of jobs, a dedicated 4WD touring / off-grid specialist is a better fit.",
      },
      {
        q: "How big should my DC-DC charger be?",
        a: "Generally 20% of your battery's amp-hour rating, capped by your alternator's spare capacity. A 100Ah AGM pairs well with a 20A REDARC BCDC. We'll spec the right size during your quote.",
      },
      {
        q: "Do you service caravans or camper vans too?",
        a: "No. Powerz Auto Electrical is an auto electrical workshop — we work on Vehicles only. We do NOT do caravan or camper-van interior fitouts, repairs, or any wiring inside a caravan or camper van. We will install the tow-vehicle side of a dual battery, Anderson plug or 12 pin setup so it can connect to your existing caravan or camper via the plug — but anything past the plug needs a dedicated caravan / camper-van electrical specialist.",
      },
      {
        q: "Which Sunshine Coast suburbs do you service for under-bonnet dual battery installs?",
        a: "All of them. Maroochydore, Mooloolaba, Caloundra, Noosa, Buderim, Kunda Park, Nambour, Sippy Downs, Coolum, Mount Coolum, Yaroomba, Peregian, Kawana, Bli Bli, Palmwoods, Yandina, Eumundi, Tewantin, Beerwah and Landsborough.",
      },
    ],
  },

  {
    slug: "auto-air-conditioning",
    name: "Auto Air Conditioning Sunshine Coast",
    h1: "Auto Air Conditioning Sunshine Coast",
    kicker: "Cars, 4WDs, trucks & machinery — A/C Service from $154",
    metaTitle: "Auto Air Conditioning Sunshine Coast | A/C Service From $154 | Powerz Auto Electrical",
    metaDesc: "Auto air conditioning service & repairs on the Sunshine Coast. A/C Service from $154 (GST inc) — includes a nitrogen pressure test, valve reseal, high & low side system pressure check and a regas. Leak detection, compressor replacement, full vehicle A/C diagnostics. ARC-licensed workshop at Kunda Park for customers from Maroochydore, Caloundra, Noosa and all Sunshine Coast suburbs.",
    image: "/pricing/ac-diagnostic.jpg",
    relatedReviewService: ["Auto Air Conditioning"],
    relatedShop: null,
    relatedServices: [
      "auto-electrician-sunshine-coast",
    ],
    relatedBlogs: [
      "how-to-know-if-you-need-ac-diagnostic",
      "what-checked-before-ac-performance-test",
    ],
    priceFrom: "$154",
    intro: [
      "There's nothing worse than a Queensland summer on the Sunshine Coast with no working A/C. At Powerz Auto Electrical we specialise in auto air conditioning service, regas and repairs from our Kunda Park workshop — for cars, 4WDs, utes, trucks, vans and machinery across every Sunshine Coast suburb. Our A/C Service starts at $154 GST included and includes a nitrogen pressure test, valve reseal, high & low side system pressure check and a regas — no surprises.",
      "We're ARC-licensed refrigerant handlers, which matters more than you'd think. Under Australian law, an A/C system with a confirmed leak can't legally just be re-gassed — and we won't do it. If we find a leak during diagnostic, we'll tell you exactly where it is and quote the repair before going any further. Customers come to us from Maroochydore, Caloundra, Noosa, Buderim, Mooloolaba, Coolum, Nambour, Sippy Downs and every Sunshine Coast suburb.",
    ],
    whatsIncluded: [
      "Full electronic leak detection with dye and sniffer",
      "Refrigerant evacuation, recovery and recharge to manufacturer spec",
      "Pressure testing to verify system integrity",
      "Compressor performance testing",
      "Cabin temperature drop testing — we make sure it's actually blowing cold before you leave",
      "PAG oil top-up if required",
      "ARC-compliant refrigerant handling — every job logged",
    ],
    whyUs: [
      "A/C Service from $154 GST included — nitrogen pressure test, valve reseal, high & low pressure check and regas",
      "ARC-licensed — your job is logged and compliant",
      "We service everything on the Sunshine Coast from sedans to mine machinery",
      "Honest diagnostics — no upselling, no shotgunning parts",
    ],
    pricing: {
      label: "Pricing (GST included)",
      items: [
        { name: "A/C Service (starting price)", price: "From $154" },
        { name: "A/C Repairs (compressor, condenser, hoses)", price: "Quoted on diagnosis" },
      ],
      note: "Australian law (ARC) prevents us from re-gassing a known-leaky system — leaks must be repaired first.",
    },
    process: [
      { title: "Book in", body: "Call 0428 182 015 to book your A/C Service (from $154) at our Kunda Park workshop. Same-day service is usually available." },
      { title: "Service & regas", body: "Nitrogen pressure test, valve reseal, high & low side pressure check, electronic leak detection, then evacuate, recover and recharge to manufacturer spec. PAG oil top-up if required." },
      { title: "Test & sign off", body: "Cabin temperature drop test before you leave — we confirm it's actually blowing cold. If a leak is found, we'll quote any repair work before going further." },
    ],
    faq: [
      {
        q: "How much does an A/C service cost on the Sunshine Coast?",
        a: "Our A/C Service starts at $154 GST included. That starting price includes a nitrogen pressure test, valve reseal, high & low side system pressure check and a regas. Repairs or extra refrigerant for larger systems are quoted before we proceed.",
      },
      {
        q: "Why can't I just regas my A/C if it has a leak?",
        a: "Australian refrigerant law (administered by the ARC — Australian Refrigeration Council) prohibits releasing refrigerant into the atmosphere. If a system has a leak, refilling it means new gas leaks out — that's illegal and we'd lose our licence. Leaks must be repaired first.",
      },
      {
        q: "How long does the A/C service take?",
        a: "Typically 1-1.5 hours at our Kunda Park workshop. Same-day service for most Sunshine Coast bookings.",
      },
      {
        q: "Do you do A/C work on trucks and machinery?",
        a: "Yes — cars, 4WDs, utes, trucks, vans and machinery. Same $154 starting price, although larger systems with higher gas capacity may incur an additional charge for extra refrigerant.",
      },
      {
        q: "Which Sunshine Coast suburbs do you service for A/C work?",
        a: "All of them. Maroochydore, Mooloolaba, Caloundra, Noosa, Buderim, Kunda Park, Nambour, Sippy Downs, Coolum, Mount Coolum, Yaroomba, Peregian, Kawana, Bli Bli, Palmwoods, Yandina, Eumundi, Tewantin, Beerwah and Landsborough.",
      },
    ],
  },

  {
    slug: "4x4-auto-electrical-sunshine-coast",
    name: "4x4 Auto Electrical Sunshine Coast",
    h1: "4x4 Auto Electrical Sunshine Coast",
    kicker: "Specialist 4WD electrical — Kunda Park workshop",
    metaTitle: "4x4 Auto Electrical Sunshine Coast | 4WD Specialist | Powerz Auto Electrical Kunda Park",
    metaDesc: "Specialist 4x4 auto electrical on the Sunshine Coast — under-bonnet dual battery, REDARC BCDC charging, driving lights, UHF radios, brake controllers and accessory wiring. Workshop at Kunda Park for customers from Maroochydore, Caloundra, Noosa, Buderim and every Sunshine Coast 4WD owner.",
    image: "/gallery/4wd-auto-electrical-fitout-sunshine-coast.jpg",
    relatedReviewService: ["Auto Electrical", "Dual Battery", "12V / Wiring"],
    relatedShop: "4wd-accessories",
    relatedServices: [
      "dual-battery-systems",
      "redarc-bcdc-installation-sunshine-coast",
      "uhf-radio-installation-sunshine-coast",
      "driving-lights-spotlights-installation-sunshine-coast",
    ],
    relatedBlogs: [
      "why-is-my-cars-electrical-system-failing",
      "why-wont-my-car-start-electrical-checklist",
      "what-causes-most-automotive-electrical-failures",
    ],
    priceFrom: "$165/hr",
    intro: [
      "4x4 auto electrical work is what Powerz Auto Electrical does day in and day out. LandCruiser, Hilux, Ranger, D-MAX, Patrol, Prado, Everest, Amarok, Triton, MU-X, Colorado, Navara and the growing range of American-built trucks moving into the Sunshine Coast — the diagnostics, the wiring, the accessory installs are all our bread and butter. Workshop at Kunda Park, for customers from Maroochydore, Mooloolaba, Caloundra, Noosa, Buderim, Sippy Downs, Coolum, Peregian and every Sunshine Coast suburb between.",
      "4WDs push their electrical systems harder than any other passenger vehicle — auxiliary loads, extra lighting, camp gear, UHF comms, dual batteries, brake controllers, dashcams and reversing cameras all live off the alternator. Get any of it wrong and you're looking at cooked fuses, flattened batteries, melted looms or dash warning lights that never clear. Get it right the first time — heat-shrink terminations, properly-sized fuses at the source, factory-look loom routing — and it just works, trip after trip.",
    ],
    whatsIncluded: [
      "Under-bonnet dual battery installs (AGM auxiliary in the factory tray location, REDARC BCDC DC-DC charging)",
      "REDARC Tow-Pro Elite electric brake controller installs — Basic, Smart and Next-Gen Ranger / Amarok tiers",
      "Anderson plug installs (Grey for accessory / camper trailer, Red for jump-start, always relay-controlled where fitted)",
      "UHF radio installs — GME, Uniden, bullbar-antenna, dash-mount, chassis-earthed",
      "Driving light and light bar installs — Stedi, Lightforce, Roadvision, ARB — behind-grille, bullbar, roof",
      "Reverse camera and dashcam retrofits — factory-integrated where possible",
      "12V accessory circuits — fridges, water pumps, inverters, camp lighting, USB and Anderson outlets",
      "Full 4WD electrical fault diagnostics — no-starts, parasitic drains, warning lights, harness damage",
    ],
    whyUs: [
      "10+ years of hands-on 4x4 electrical experience at the bench",
      "26+ completed 4x4 builds photographed and documented on our website",
      "REDARC Tow-Pro, BCDC, SBI-12 and Manager — supply & install",
      "Under-bonnet specialist — no boot batteries, no drawer-mounted compromises",
      "Heat-shrink terminations, ANL fusing, factory-look loom routing on every job",
      "Workshop at 2a/3 Hitech Dr Kunda Park — 5 minutes off the Bruce Highway",
      "12-month workmanship warranty on every install",
    ],
    pricing: {
      label: "4x4 Auto Electrical Pricing (GST included)",
      items: [
        { name: "Workshop diagnostic rate", price: "$165/hr" },
        { name: "Minimum charge per job", price: "1 hour" },
        { name: "REDARC Tow-Pro Elite — Basic install", price: "$805" },
        { name: "Under-bonnet dual battery install", price: "From ~$1,200" },
        { name: "12 pin trailer plug install (basic)", price: "From $495*" },
      ],
      note: "*Price shown is for a basic 12 pin plug install. Additional charges may apply if extra pins or circuits are required. Every 4x4 install is quoted in writing before any work starts. Larger multi-job fitouts (dual battery + brake controller + UHF + driving lights) are booked as a single workshop day and priced up-front.",
    },
    process: [
      { title: "Send us your vehicle & wishlist", body: "Make, model, year and the accessories you want fitted. We'll confirm what's already in your factory harness and spec the right hardware." },
      { title: "Written quote", body: "Every 4x4 job is quoted in writing before booking. No parts-cannon surprises, no scope creep." },
      { title: "Workshop install", body: "Booked into a dedicated workshop day at Kunda Park. Most single-service installs done same-day; full multi-job fitouts are a single workshop day." },
      { title: "Handover", body: "Walkthrough of the install, a photo record of the wiring for your records, workmanship warranty in writing." },
    ],
    faq: [
      {
        q: "Do you specialise in 4x4 electrical or is it just something you do?",
        a: "4x4 electrical is our specialty. Under-bonnet dual battery, REDARC brake controllers, UHF, driving lights, accessory wiring, diagnostics — this is the bulk of what we do every week at our Kunda Park workshop. Our completed-builds page has 26 real 4WD jobs with photos and full writeups.",
      },
      {
        q: "Can you fit everything in one workshop visit?",
        a: "Yes — we regularly do multi-job 4WD fitouts in a single workshop day. Dual battery + brake controller + UHF + driving lights + Anderson plug is a common combo. Book the vehicle in for a full day and we'll knock the lot out.",
      },
      {
        q: "Do you install lithium 4x4 house-banks or full off-grid setups?",
        a: "No — Powerz Auto Electrical specialises in under-bonnet AGM dual battery only. We do NOT install lithium house-banks, off-grid setups, solar systems, MPPT regulators, inverters or full touring fitouts. For those, a dedicated 4WD / off-grid specialist is a better fit.",
      },
      {
        q: "Which Sunshine Coast suburbs do you service for 4x4 electrical?",
        a: "All of them. Workshop at 2a/3 Hitech Dr, Kunda Park — 5 minutes off the Bruce Highway, easy from Maroochydore, Mooloolaba, Caloundra, Noosa, Buderim, Sippy Downs, Coolum, Peregian and everywhere between.",
      },
      {
        q: "Do you work on caravans as part of a 4x4 fitout?",
        a: "No. Powerz Auto Electrical works on Vehicles only. Our work on any tow vehicle stops at the trailer plug or Anderson plug. Caravan-side and camper-van-side wiring must be carried out by a dedicated caravan / camper-van electrical specialist.",
      },
    ],
  },

  {
    slug: "uhf-radio-installation-sunshine-coast",
    name: "UHF Radio Installation Sunshine Coast",
    h1: "UHF Radio Installation Sunshine Coast",
    kicker: "GME, Uniden — bullbar antenna, factory-look dash mount",
    metaTitle: "UHF Radio Installation Sunshine Coast | GME & Uniden Installers | Powerz Auto Electrical",
    metaDesc: "Professional UHF radio installation on the Sunshine Coast. GME and Uniden supply and install — bullbar antenna, chassis-earthed, ignition-switched 12V, factory-look dash mount. Workshop at Kunda Park for customers from Maroochydore, Caloundra, Noosa, Buderim and every Sunshine Coast 4WD owner.",
    image: "/builds/rileys-n80-hilux-uhf-install-sunshine-coast.jpg",
    relatedReviewService: ["Auto Electrical", "12V / Wiring"],
    relatedShop: "uhf",
    relatedServices: [
      "4x4-auto-electrical-sunshine-coast",
      "driving-lights-spotlights-installation-sunshine-coast",
    ],
    relatedBlogs: [
      "what-tools-do-auto-electricians-use",
      "why-is-my-cars-electrical-system-failing",
    ],
    priceFrom: "From $395",
    intro: [
      "A properly installed UHF radio is the difference between reliable comms when you need them and an aftermarket accessory you stop using. Powerz Auto Electrical is a Sunshine Coast specialist installer of GME and Uniden UHF radios — bullbar-mounted antennas with a solid chassis earth, ignition-switched 12V supplies with inline fusing, heat-shrunk terminations, and factory-look dash mounts. Workshop at Kunda Park for customers from Maroochydore, Mooloolaba, Caloundra, Noosa, Buderim, Sippy Downs, Coolum, Peregian and every Sunshine Coast suburb.",
      "UHF performance lives and dies on the quality of the install. The antenna needs a proper chassis earth (which matters more than most people realise), the coax needs to be routed without kinks or crush-points, and the head unit needs a clean 12V supply that doesn't inject alternator whine into the audio. Get any of it wrong and you've got a 5-watt UHF broadcasting like a 1-watt handheld — with the range to prove it.",
    ],
    whatsIncluded: [
      "Supply and install of a genuine GME or Uniden UHF head unit (5W standard, mobile 80-channel)",
      "Bullbar-mounted UHF antenna — 4.5dBi to 9dBi depending on your usage (open-country vs urban)",
      "Solid chassis earth to the antenna mount — no compromise on RF performance",
      "Ignition-switched 12V feed with proper inline fusing (no cigarette-lighter power theft)",
      "Coax routed through factory grommets, loomed and secured — no visible cable runs",
      "Factory-look dash mount for the head unit (compact controller / remote head where the vehicle supports it)",
      "Full range and function test on multiple channels before you leave the workshop",
      "12-month workmanship warranty (UHF unit carries its own manufacturer warranty)",
    ],
    whyUs: [
      "Specialist UHF installer — we do them every week, not once a year",
      "GME and Uniden UHF — supply & install",
      "Bullbar antenna as standard — no body panel drilling, no rust risk down the track",
      "Every install includes function test on multiple channels before you drive away",
      "Sunshine Coast workshop at Kunda Park — 5 minutes off the Bruce Highway",
      "12-month workmanship warranty on every install",
    ],
    pricing: {
      label: "UHF Radio Installation Pricing (GST included)",
      items: [
        { name: "GME / Uniden UHF supply & install — standard 5W", price: "From $395" },
        { name: "UHF install with premium Uniden Off Road Pack / GME XRS", price: "Quoted on request" },
        { name: "Antenna-only install (customer-supplied UHF)", price: "From $220" },
      ],
      note: "Pricing depends on the head unit and antenna spec you select. Every UHF install is quoted in writing before booking. Multi-vehicle fleet UHF installs are quoted separately. Customer-supplied gear is fitted case-by-case under our Customer-Supplied Parts policy: workmanship-only warranty, chargeable labour if the part is faulty or incompatible, no liability for damage caused by the part — see /policies.",
    },
    process: [
      { title: "Confirm vehicle & UHF choice", body: "Send us your vehicle make/model and we'll recommend the right UHF and antenna combo — most 4WD owners want a bullbar-mounted 6.6dBi antenna with a 5W GME or Uniden head unit." },
      { title: "Workshop install", body: "Most UHF installs are done in half a day at our Kunda Park workshop. Coax routed properly, chassis-earthed antenna, ignition-switched supply." },
      { title: "Function test & handover", body: "We function-test on multiple channels before handover, walk you through the head unit, and hand back a fully working UHF setup with the workmanship warranty in writing." },
    ],
    faq: [
      {
        q: "Do you install GME or Uniden UHF radios?",
        a: "Both. GME XRS-Connect, Uniden UH9080 Off Road Pack, standard GME TX3350 and Uniden UH5060 are all common installs. Send us the model number or ask us for a recommendation for your vehicle and usage.",
      },
      {
        q: "Why does the antenna have to be bullbar-mounted?",
        a: "Two reasons — solid chassis earth (which matters more than most people realise for UHF performance), and no body panel drilling (so no rust risk down the track). The antenna sits high enough to clear most driving scenarios and gives the cleanest install we can do.",
      },
      {
        q: "How long does a UHF install take?",
        a: "About half a day at our Kunda Park workshop. Longer if you've picked a remote-head unit that needs cabin dash work.",
      },
      {
        q: "Can you install a UHF I've bought myself?",
        a: "Yes — we're happy to install a customer-supplied UHF. Antenna-only installs from $220, full head-unit-and-antenna installs quoted based on the specific gear. Note: we can't warranty the UHF hardware itself if you've supplied it, only the install workmanship — and any labour caused by a faulty or incompatible unit is chargeable. Full conditions on our Policies page.",
      },
      {
        q: "Which Sunshine Coast suburbs do you service for UHF installs?",
        a: "All of them. Workshop at 2a/3 Hitech Dr, Kunda Park — for customers from Maroochydore, Mooloolaba, Caloundra, Noosa, Buderim, Sippy Downs, Coolum, Peregian and every Sunshine Coast suburb.",
      },
    ],
  },

  {
    slug: "driving-lights-spotlights-installation-sunshine-coast",
    name: "Driving Lights & Spotlights Installation Sunshine Coast",
    h1: "Driving Lights & Spotlights Installation Sunshine Coast",
    kicker: "Stedi, Lightforce, Roadvision — behind-grille and bullbar installs",
    metaTitle: "Driving Lights Installation Sunshine Coast | Stedi & Lightforce Installers | Powerz Auto Electrical",
    metaDesc: "Professional driving lights and spotlights installation on the Sunshine Coast. Stedi, Lightforce, Roadvision, ARB — behind-grille, bullbar and roof-mount installs done factory-look. Workshop at Kunda Park for customers from Maroochydore, Caloundra, Noosa, Buderim and every Sunshine Coast 4WD owner.",
    image: "/builds/next-gen-ford-everest-grill-lights-install-coolum-sunshine-coast.jpg",
    relatedReviewService: ["Auto Electrical", "Driving Lights", "12V / Wiring"],
    relatedShop: "4wd-accessories",
    relatedServices: [
      "4x4-auto-electrical-sunshine-coast",
      "uhf-radio-installation-sunshine-coast",
    ],
    relatedBlogs: [
      "what-tools-do-auto-electricians-use",
      "why-is-my-cars-electrical-system-failing",
    ],
    priceFrom: "From $395",
    intro: [
      "Driving lights done properly pair a serious beam pattern with a factory-look install — no drilled panels, no cable-tie wiring, no cooked radiators from mounting the wrong light in the wrong spot. Powerz Auto Electrical installs driving lights, spotlights and LED light bars for customers from across the Sunshine Coast — Stedi, Lightforce, Roadvision, ARB and other premium brands. Workshop at Kunda Park for customers from Maroochydore, Mooloolaba, Caloundra, Noosa, Buderim, Sippy Downs, Coolum, Peregian and every Sunshine Coast suburb.",
      "The install matters as much as the light. A bullbar-mounted pair with a heat-shrunk, loomed harness and a properly-fused ignition-switched supply will outlast the vehicle. A cheap plug-and-play kit crimped in the engine bay with scotch-locks will die on the first hot Queensland run. We spec the right light for your vehicle, mount it in the right place, and wire it so it won't be the reason you're stuck at the side of the road with a burnt fuse.",
    ],
    whatsIncluded: [
      "Genuine Stedi, Lightforce, Roadvision, ARB or customer-choice driving lights / LED bars / spotlights",
      "Correct mounting hardware — bullbar tab, behind-grille bracket, roof bar or A-pillar mount",
      "Loomed harness with heat-shrunk crimp lug terminations end-to-end",
      "Properly-fused ignition-switched 12V supply — high-beam-trigger relay where appropriate",
      "In-cabin switch installed in a factory blank position (or wired to a factory high-beam trigger)",
      "Beam pattern aim-in on a marked wall before handover — no dazzling oncoming traffic",
      "12-month workmanship warranty on the install (lights carry their own manufacturer warranty)",
    ],
    whyUs: [
      "Behind-grille specialist — the cleanest driving light install if the vehicle can accommodate it",
      "Stedi, Lightforce, Roadvision — supply & install",
      "Heat-shrink terminations, loomed harness, factory-look finish on every install",
      "Beam pattern aim-in included — no returning for adjustments",
      "Sunshine Coast workshop at Kunda Park — 5 minutes off the Bruce Highway",
      "12-month workmanship warranty on every install",
    ],
    pricing: {
      label: "Driving Lights & Spotlights Pricing (GST included)",
      items: [
        { name: "Bullbar-mounted driving lights — install with customer-supplied harness", price: "From $395" },
        { name: "Bullbar-mounted driving lights — supply & install (Stedi / Roadvision pair)", price: "Quoted on request" },
        { name: "Behind-grille LED driving lights — install", price: "From $495" },
        { name: "LED light bar — supply & install", price: "Quoted on request" },
      ],
      note: "Every driving light install is quoted in writing before booking. Behind-grille installs on some vehicles (Next-Gen Ranger, Everest, Amarok) can take extra workshop time due to grille geometry — we always quote up-front. Customer-supplied gear is fitted case-by-case under our Customer-Supplied Parts policy: workmanship-only warranty, chargeable labour if the part is faulty or incompatible, no liability for damage caused by the part — see /policies.",
    },
    process: [
      { title: "Spec the right light", body: "Send us your vehicle and how you use it. We'll recommend the right light for the mounting location, beam pattern and thermal envelope of your vehicle." },
      { title: "Workshop install", body: "Most driving light installs are done same-day at our Kunda Park workshop. Behind-grille installs on complex vehicles may need a full workshop day." },
      { title: "Aim-in & handover", body: "We aim the beam pattern on a marked wall before you leave the workshop — no dazzled oncoming traffic, no returning to have them adjusted." },
    ],
    faq: [
      {
        q: "Which brands do you install?",
        a: "Stedi, Lightforce, Roadvision, ARB, Ultra Vision, PIAA and others. We generally steer customers toward Stedi and Lightforce for the best beam pattern and thermal management for Australian conditions, but we'll install what you've bought.",
      },
      {
        q: "Behind-grille vs bullbar — which is better?",
        a: "Both work well when done right. Behind-grille is the cleanest look — the lights are invisible until turned on — but only some vehicles have enough grille depth and airflow. Bullbar-mounted is the most flexible option and works on any 4WD with a bullbar. We'll recommend which suits your vehicle when you send us the make and model.",
      },
      {
        q: "Can you wire the driving lights to my factory high-beam?",
        a: "Yes — most driving light installs are wired via a relay triggered by the factory high-beam feed, so they come on with high-beam and off with low-beam automatically. We also fit a manual over-ride switch in a factory dash blank so you can isolate them when you don't want them coming on.",
      },
      {
        q: "How long does a driving light install take?",
        a: "Bullbar-mounted pair with a supplied harness is typically half a day. Behind-grille installs on complex vehicles (Next-Gen Ranger, Everest, Amarok) can take a full workshop day. We'll quote the specific time before booking.",
      },
      {
        q: "Which Sunshine Coast suburbs do you service for driving light installs?",
        a: "All of them. Workshop at 2a/3 Hitech Dr, Kunda Park — for customers from Maroochydore, Mooloolaba, Caloundra, Noosa, Buderim, Sippy Downs, Coolum, Peregian and every Sunshine Coast suburb.",
      },
    ],
  },

  {
    slug: "towing-electrics-sunshine-coast",
    name: "Towing Electrics Sunshine Coast",
    h1: "Towing Electrics Sunshine Coast",
    kicker: "Trailer plugs, brake controllers, Anderson plugs — done properly",
    metaTitle: "Towing Electrics Sunshine Coast | Trailer Plug, Brake Controller, Anderson Plug | Powerz",
    metaDesc: "Powerz Auto Electrical is a Sunshine Coast towing electrical specialist. 12-pin trailer plug wiring, REDARC Tow-Pro brake controllers, Anderson plugs, ignition-controlled charging feeds. Workshop at Kunda Park servicing all Sunshine Coast tow vehicles.",
    image: "/gallery/towing-electrics-trailer-wiring-sunshine-coast.jpg",
    relatedReviewService: ["Towing Electrics"],
    relatedShop: "towing-electrics",
    relatedServices: [
      "redarc-brake-controllers",
      "anderson-plug-installation-sunshine-coast",
      "12-pin-trailer-plug-install",
      "caravan-tow-vehicle-electrical-sunshine-coast",
    ],
    relatedBlogs: [
      "what-brake-controller-do-i-need",
      "300-series-landcruiser-tow-pro-install",
      "why-is-my-cars-electrical-system-failing",
    ],
    priceFrom: "From $495",
    intro: [
      "Towing electrics is one of the biggest slices of what we do at Powerz Auto Electrical — every week, at our Kunda Park workshop, we wire up tow vehicles from across the Sunshine Coast for caravans, camper trailers, box trailers and boat trailers. 12-pin trailer plugs, REDARC Tow-Pro electric brake controllers, Anderson plugs for auxiliary charging, ignition-controlled feeds, constant battery feeds and tow-vehicle-side caravan charging setups.",
      "The right towing electrical setup is the difference between reliable weekend touring and a rolling headache. We spec each install to the specific tow vehicle and trailer combination, wire it into the vehicle's factory harness (never scotch-locks, never cigarette-lighter power theft), and hand it back with a full function test on both sides of the plug.",
    ],
    whatsIncluded: [
      "12-pin flat trailer plug installs — factory-look, wired to the correct positions for brakes, reverse, park, aux and charge",
      "REDARC Tow-Pro Elite electric brake controller installs — Basic, Smart-Wire and Amarok/Next-Gen Ranger tiers",
      "Anderson plug installs — Grey (accessory / caravan charge), Red (jump-start), relay-controlled where appropriate",
      "Ignition-controlled charging feeds — battery only charges when the vehicle is running, protecting the start battery",
      "Constant battery feeds — for caravan lights, radios and other trailer-side low-draw circuits",
      "Tow-vehicle-side caravan charging setups — Anderson plug + charge relay on the tow vehicle only",
      "Full function test on brakes, indicators, tail, reverse, park and charge before handover",
    ],
    whyUs: [
      "Towing electrics is a core specialty — we do them every week",
      "REDARC Tow-Pro Elite, BCDC, SBI-12 and Manager — supply & install",
      "Every install includes a full function test on both sides of the plug",
      "Heat-shrunk crimp terminations, ANL fusing, factory-look loom routing",
      "Workshop at 2a/3 Hitech Dr Kunda Park — 5 minutes off the Bruce Highway",
      "12-month workmanship warranty on every install",
    ],
    pricing: {
      label: "Towing Electrics Pricing (GST included)",
      items: [
        { name: "12 pin trailer plug install (basic)", price: "From $495*" },
        { name: "REDARC Tow-Pro Elite — Basic install", price: "$805" },
        { name: "REDARC Tow-Pro Elite — Smart-Wire install", price: "$855" },
        { name: "REDARC Tow-Pro Elite — Amarok / Next-Gen Ranger & Everest", price: "$1,080.38" },
        { name: "Grey Anderson plug install — no relay / with relay", price: "$495 / $550" },
      ],
      note: "*Price shown is for a basic 12 pin plug install. Additional charges may apply if extra pins or circuits are required. Every towing electrical job is quoted in writing before booking. Multi-job installs (12 pin + Anderson + Tow-Pro) are commonly booked as a single workshop day.",
    },
    process: [
      { title: "Confirm the vehicle & trailer", body: "Make, model, year and what you're towing. We'll spec the right combination of trailer plug, brake controller and Anderson plug for your setup." },
      { title: "Written quote", body: "Every job is quoted in writing before booking — no surprises at pickup." },
      { title: "Workshop install", body: "Booked into a dedicated workshop day at Kunda Park. Most single-service installs same-day; full multi-job towing setups a single workshop day." },
      { title: "Function test & handover", body: "Full function test on brakes, indicators, park, tail, reverse and charge. Warranty in writing." },
    ],
    faq: [
      {
        q: "Do you install brake controllers, Anderson plugs and trailer plugs?",
        a: "Yes — all three. Book them as separate jobs or knock them out as a single workshop day if you're doing a full towing electrical setup.",
      },
      {
        q: "Which brake controller do you recommend for towing a caravan?",
        a: "The REDARC Tow-Pro Elite. Proportional braking, hidden install, sealed for Australian conditions, 5-year REDARC warranty. See our full brake controller buyer's guide for the reasoning.",
      },
      {
        q: "Do you work on the caravan-side wiring?",
        a: "No. Powerz Auto Electrical works on Vehicles only. Our work stops at the trailer plug or Anderson plug on the vehicle side. Caravan-side and camper-van-side wiring must be carried out by a dedicated caravan / camper-van electrical specialist. This is a firm boundary.",
      },
      {
        q: "How long does a full towing electrical setup take?",
        a: "12-pin trailer plug alone is typically half a day. Full setup (12-pin + Anderson + Tow-Pro Elite) is a single workshop day at Kunda Park.",
      },
      {
        q: "Which Sunshine Coast suburbs do you service for towing electrics?",
        a: "All of them. Workshop at 2a/3 Hitech Dr Kunda Park — for customers from Maroochydore, Mooloolaba, Caloundra, Noosa, Buderim, Sippy Downs, Coolum, Peregian and every Sunshine Coast suburb.",
      },
    ],
  },

  {
    slug: "anderson-plug-installation-sunshine-coast",
    name: "Anderson Plug Installation Sunshine Coast",
    h1: "Anderson Plug Installation Sunshine Coast",
    kicker: "Grey and Red Anderson plugs — properly fused, factory-look install",
    metaTitle: "Anderson Plug Installation Sunshine Coast | Grey & Red Anderson | Powerz Auto Electrical",
    metaDesc: "Professional Anderson plug installation on the Sunshine Coast. Grey Anderson for caravan/trailer charging, Red Anderson for jump-start. Properly fused, relay-controlled where appropriate, factory-look mount. Kunda Park workshop.",
    image: "/builds/isuzu-dmax-grey-anderson-plug-sbi12-battery-isolator-install-sunshine-coast.jpg",
    relatedReviewService: ["Towing Electrics", "12V / Wiring"],
    relatedShop: "towing-electrics",
    relatedServices: [
      "towing-electrics-sunshine-coast",
      "12-pin-trailer-plug-install",
      "dual-battery-systems",
      "caravan-tow-vehicle-electrical-sunshine-coast",
    ],
    relatedBlogs: [
      "what-brake-controller-do-i-need",
      "what-size-bcdc-charger-do-i-need",
    ],
    priceFrom: "From $495",
    intro: [
      "An Anderson plug is the standard way to move high-current DC power between a tow vehicle and a trailer, caravan or auxiliary battery. Powerz Auto Electrical installs Grey Anderson plugs (for caravan / trailer charging) and Red Anderson plugs (for jump-start applications) properly — fused at both ends, relay-controlled where appropriate, and neatly mounted so it doesn't look like an aftermarket bolt-on.",
      "The install matters as much as the plug itself. Under-sized cable, missing fuses, wrong colour code, or a plug wired straight to the start battery are the four mistakes we see every week when customers bring in a botched DIY job. Get it right the first time — proper cable size for the run length, ANL fuse within 300mm of each battery terminal, ignition-controlled relay so the trailer can't flatten the tow vehicle overnight — and it just works for the life of the vehicle.",
    ],
    whatsIncluded: [
      "Grey Anderson plug — for accessory power / caravan-charge / auxiliary battery-to-battery charging",
      "Red Anderson plug — for jump-start / rescue-charge applications (different colour so plugs cannot be cross-connected)",
      "Correct cable sizing for the run length — typically 6 B&S or heavier for caravan-charge runs",
      "ANL fuse within 300mm of each battery terminal (source AND destination)",
      "Ignition-controlled charging relay where appropriate — prevents trailer flattening the tow vehicle overnight",
      "Bullbar or bumper-mounted plug in a factory-look bracket — sealed against dust and water",
      "Heat-shrunk crimp lug terminations end-to-end — never bolt-through-eyelet compromises",
      "Full continuity and polarity test before handover",
    ],
    whyUs: [
      "Anderson plug specialist — we do them every week for caravan and trailer charging",
      "Correct cable-size / fuse-position calcs done in the workshop, not guessed",
      "Colour-code discipline — Grey and Red are wired to different purposes, physically incompatible",
      "Workshop at 2a/3 Hitech Dr Kunda Park — 5 minutes off the Bruce Highway",
      "12-month workmanship warranty on every install",
    ],
    pricing: {
      label: "Anderson Plug Installation Pricing",
      items: [
        { name: "Grey Anderson (caravan / trailer charge) — no relay", price: "$495" },
        { name: "Grey Anderson (caravan / trailer charge) — with relay", price: "$550" },
        { name: "Red Anderson (jump-start) — install", price: "Quoted on inspection" },
        { name: "Grey + Red Anderson combo install", price: "Quoted on inspection" },
      ],
      note: "Grey Anderson prices are GST inc for a standard install at our Kunda Park workshop. Unusually long cable runs, custom mount locations or combo installs are quoted in writing before booking.",
    },
    process: [
      { title: "Send us your vehicle & use case", body: "Are you charging a caravan? Powering an aux battery in a canopy? Jump-starting between vehicles? The purpose determines colour, cable size and whether we need a relay." },
      { title: "Written quote", body: "We inspect the vehicle, measure the cable run, spec the fusing and quote in writing before booking." },
      { title: "Workshop install", body: "Most Anderson plug installs are done in half to a full workshop day at our Kunda Park workshop." },
      { title: "Test & handover", body: "Continuity, polarity and (where relay-controlled) ignition-cycle test before handover. Warranty in writing." },
    ],
    faq: [
      {
        q: "Do I need a Grey or a Red Anderson plug for my caravan?",
        a: "Grey. Grey is the Australian standard colour for accessory / caravan-charge circuits. Red is reserved for jump-start applications so the two can never be cross-connected.",
      },
      {
        q: "Should my Anderson plug be ignition-controlled?",
        a: "For charging a caravan or auxiliary battery — yes, almost always. An ignition-controlled relay means the trailer can only draw from the tow vehicle when the vehicle is running, which stops the trailer flattening your start battery overnight. For simple 12V accessory outlets we discuss the trade-offs during the quote.",
      },
      {
        q: "What size cable do I need for my Anderson plug run?",
        a: "Depends on the run length and the current you're running. For most caravan-charge runs (5-7 metres, 30-50A of DC current) we use 6 B&S copper. For longer runs or bigger currents we step up to 4 B&S. We size the cable in the workshop based on your specific vehicle.",
      },
      {
        q: "Can I install an Anderson plug myself?",
        a: "Technically yes. Practically — the four mistakes we see every week (undersized cable, missing fuses, wrong colour code, no relay) turn a $150 DIY job into a workshop repair that costs more than the professional install would have. It's the wrong job to learn on.",
      },
      {
        q: "Do you work on the caravan-side of the Anderson plug?",
        a: "No. Powerz Auto Electrical works on Vehicles only. Our work stops at the plug on the tow-vehicle side. Caravan-internal wiring must be done by a dedicated caravan / camper-van electrical specialist.",
      },
    ],
  },

  {
    slug: "redarc-bcdc-installation-sunshine-coast",
    name: "REDARC BCDC Installation Sunshine Coast",
    h1: "REDARC BCDC Installation Sunshine Coast",
    kicker: "BCDC1225D & BCDC1240D — under-bonnet, factory-look install",
    metaTitle: "REDARC BCDC Installation Sunshine Coast | BCDC1225D & BCDC1240D Installer | Powerz",
    metaDesc: "Powerz Auto Electrical installs REDARC BCDC1225D and BCDC1240D DC-DC chargers on the Sunshine Coast — under-bonnet, factory-look, with proper cable sizing and ANL fusing. Kunda Park workshop for customers from Maroochydore, Caloundra, Noosa, Buderim.",
    image: "/builds/keiles-200-series-landcruiser-engine-bay-dual-battery-install-peregian-springs.jpg",
    relatedReviewService: ["Dual Battery", "Auto Electrical"],
    relatedShop: null,
    relatedServices: [
      "dual-battery-systems",
      "4x4-auto-electrical-sunshine-coast",
      "anderson-plug-installation-sunshine-coast",
    ],
    relatedBlogs: [
      "what-size-bcdc-charger-do-i-need",
      "what-causes-most-automotive-electrical-failures",
    ],
    priceFrom: "From ~$1,200 (kit + install)",
    intro: [
      "A REDARC BCDC is the brain of a properly-built dual battery system. It takes the raw, variable voltage coming out of a modern smart-alternator and converts it into a stable multi-stage charge profile the auxiliary battery actually wants. Powerz Auto Electrical is a Sunshine Coast REDARC dealer and installer — BCDC1225D (25A) and BCDC1240D (40A) are our two most-installed units, always mounted under the bonnet, always with correctly-sized cable and ANL fuses at both ends.",
      "The wrong-sized BCDC will either cook the alternator or undercharge the auxiliary. The right-sized BCDC, fitted with proper cable and fusing, is set-and-forget for the life of the vehicle. We spec each install to the specific vehicle-and-battery combination, not a one-size-fits-all rule.",
    ],
    whatsIncluded: [
      "REDARC BCDC1225D (25A) — our most-installed unit; fits most Hilux, Ranger, D-MAX, Prado, MU-X",
      "REDARC BCDC1240D (40A) — for V8 LandCruisers, Y62 Patrol, RAM 1500, F150 and similar large-alternator platforms",
      "Solar input on the BCDC1240D — future-proof for adding a panel later",
      "Under-bonnet mount — heat-tolerant location, sealed against dust and water",
      "Correctly-sized cable — 6 B&S minimum for BCDC1225D, 4 B&S for BCDC1240D",
      "ANL fuse within 300mm of BOTH battery terminals (source and destination)",
      "Ignition-controlled trigger wire on smart-alternator vehicles (per REDARC install manual)",
      "Load-test drive before handover — confirms charge current and profile are correct",
    ],
    whyUs: [
      "REDARC supply & install — genuine gear, proper warranty",
      "Under-bonnet specialist — never a boot mount, never a drawer mount",
      "Cable sizing and fuse-position calculated to REDARC spec, not guessed",
      "Load-test drive on every install before handover",
      "Workshop at 2a/3 Hitech Dr Kunda Park — 5 minutes off the Bruce Highway",
      "12-month workmanship warranty + 5-year REDARC BCDC manufacturer warranty",
    ],
    pricing: {
      label: "REDARC BCDC Installation Pricing (GST included)",
      items: [
        { name: "BCDC1225D (25A) — supply & under-bonnet install with AGM aux", price: "From ~$1,200" },
        { name: "BCDC1240D (40A) — supply & under-bonnet install with AGM aux", price: "From ~$1,450" },
        { name: "BCDC install using customer-supplied unit", price: "Quoted on inspection" },
      ],
      note: "Every BCDC install is quoted in writing after we confirm the vehicle, auxiliary battery choice and accessory loads. Prices above include a standard 100Ah AGM auxiliary in the factory tray location. Customer-supplied gear is fitted case-by-case under our Customer-Supplied Parts policy: workmanship-only warranty, chargeable labour if the part is faulty or incompatible, no liability for damage caused by the part — see /policies.",
    },
    process: [
      { title: "Send us the vehicle & use case", body: "Vehicle make/model, whether you're running a fridge, camp lights, UHF, dashcam. We'll spec the right BCDC and battery pairing." },
      { title: "Written quote", body: "Cable sizing, fusing, mount location and BCDC size confirmed in writing before booking." },
      { title: "Workshop install", body: "One workshop day at Kunda Park. Under-bonnet mount, correct cable, ANL fuses at both ends, ignition-controlled trigger where needed." },
      { title: "Load-test & handover", body: "We drive the vehicle briefly to verify BCDC is charging at the correct current and profile. Warranty in writing." },
    ],
    faq: [
      {
        q: "What size BCDC charger do I need?",
        a: "Rule of thumb: 20% of the auxiliary battery's amp-hour rating, capped by your alternator's spare capacity. 100Ah AGM → BCDC1225D (25A). 120Ah+ AGM on a V8 → BCDC1240D (40A). We size it to your specific vehicle. See our full BCDC sizing guide for the detailed logic.",
      },
      {
        q: "BCDC1225D vs BCDC1240D — which is right?",
        a: "BCDC1225D is our most-installed unit — 25A charge current, fits Hilux, Ranger, D-MAX, Prado, MU-X and similar. BCDC1240D is 40A with a solar input — for V8 LandCruisers, Y62 Patrol, RAM 1500 and future-proofing a solar panel.",
      },
      {
        q: "Do you install BCDCs under the bonnet only?",
        a: "Yes. Under-bonnet install with AGM auxiliary is our specialty and firm boundary. We do NOT install lithium house-banks in cargo areas, no boot batteries, no full 4WD touring / off-grid setups. For those, a dedicated 4WD / off-grid specialist is a better fit.",
      },
      {
        q: "How long does a BCDC install take?",
        a: "One workshop day at Kunda Park. Vehicle in first thing, load-test drive at the end.",
      },
      {
        q: "Can I add a solar panel later?",
        a: "Yes if we've fitted a BCDC1240D — it has a dedicated solar input that runs alongside the alternator input. We can wire in a solar Anderson at install-time so plugging in a panel later is a two-minute job.",
      },
    ],
  },

  {
    slug: "caravan-tow-vehicle-electrical-sunshine-coast",
    name: "Caravan Electrical (Tow Vehicle Side) Sunshine Coast",
    h1: "Caravan Electrical — Tow Vehicle Side — Sunshine Coast",
    kicker: "12-pin, Anderson plug, brake controller — tow vehicle only",
    metaTitle: "Caravan Electrical Sunshine Coast | Tow Vehicle Side | 12 Pin & Anderson Installer | Powerz",
    metaDesc: "Powerz Auto Electrical wires the tow-vehicle side for caravan owners on the Sunshine Coast — 12-pin trailer plug, Anderson plug for caravan charging, REDARC Tow-Pro brake controller. We do NOT do caravan-internal wiring. Kunda Park workshop.",
    image: "/gallery/towing-electrics-trailer-wiring-sunshine-coast.jpg",
    relatedReviewService: ["Towing Electrics"],
    relatedShop: "towing-electrics",
    relatedServices: [
      "towing-electrics-sunshine-coast",
      "redarc-brake-controllers",
      "anderson-plug-installation-sunshine-coast",
      "12-pin-trailer-plug-install",
    ],
    relatedBlogs: [
      "what-brake-controller-do-i-need",
    ],
    priceFrom: "From $495",
    intro: [
      "If you tow a caravan on the Sunshine Coast, the tow-vehicle-side electrics need to be right — a 12-pin trailer plug wired to the vehicle's factory harness, a REDARC Tow-Pro Elite for proportional trailer braking, and (where your caravan has a house battery) a Grey Anderson plug wired through an ignition-controlled relay so the tow vehicle charges the caravan on the drive without flattening its own start battery.",
      "Powerz Auto Electrical is a Sunshine Coast specialist for the tow-vehicle side of caravan electrics. Workshop at Kunda Park. We set up tow vehicles from right across the Coast — Prado, LandCruiser, Ranger, Hilux, D-MAX, Amarok, Everest and the growing range of American-built trucks — and hand them back with brakes, plugs, charging and a full function test all working together.",
    ],
    whatsIncluded: [
      "12-pin flat trailer plug installs — wired to factory positions for brakes, reverse, tail, park, aux and charge",
      "REDARC Tow-Pro Elite electric brake controller — proportional braking, hidden install",
      "Grey Anderson plug for caravan-charge — fused at both ends, ignition-controlled relay to protect the start battery",
      "Constant / ignition-controlled feeds — for caravan lights, radios and low-draw trailer-side circuits",
      "Cable sizing to REDARC spec — never guesswork",
      "Full function test on brakes, indicators, park, tail, reverse, aux and charge before handover",
    ],
    whyUs: [
      "Firm boundary: we work on the tow VEHICLE side only — never caravan internals — so we do this specific slice better than a generalist",
      "REDARC Tow-Pro Elite, BCDC and SBI-12 — supply & install",
      "Full function test on both sides of the plug before handover",
      "Workshop at 2a/3 Hitech Dr Kunda Park — 5 minutes off the Bruce Highway",
      "12-month workmanship warranty on every install",
    ],
    pricing: {
      label: "Caravan (Tow Vehicle Side) Pricing",
      items: [
        { name: "12 pin trailer plug install (basic)", price: "From $495*" },
        { name: "REDARC Tow-Pro Elite — Basic install", price: "$805" },
        { name: "REDARC Tow-Pro Elite — Smart-Wire install", price: "$855" },
        { name: "REDARC Tow-Pro Elite — Amarok / Next-Gen Ranger & Everest", price: "$1,080.38" },
        { name: "Grey Anderson caravan-charge plug install — no relay / with relay", price: "$495 / $550" },
      ],
      note: "*Price shown is for a basic 12 pin plug install. Additional charges may apply if extra pins or circuits are required. Most caravan tow-vehicle setups are booked as a single workshop day (12-pin + Tow-Pro + Anderson). Quoted in writing before booking.",
    },
    process: [
      { title: "Confirm the tow vehicle & caravan", body: "Tow vehicle make/model + year, caravan make/model + weight, and whether the caravan has a house battery you want charged on the drive." },
      { title: "Written quote", body: "Every job is quoted in writing before booking — no surprises at pickup." },
      { title: "Workshop install", body: "Booked as a single workshop day at Kunda Park for a full caravan tow-vehicle setup (12-pin + Tow-Pro + Anderson)." },
      { title: "Function test & handover", body: "Full function test on brakes, indicators, park, tail, reverse and charge on both sides of the plug. Warranty in writing." },
    ],
    faq: [
      {
        q: "Do you do caravan-internal wiring?",
        a: "No — this is a firm boundary. Powerz Auto Electrical works on Vehicles only. Our work stops at the trailer plug or Anderson plug on the tow-vehicle side. Caravan-internal wiring, camper-van fitouts and caravan house-battery systems must be done by a dedicated caravan / camper-van electrical specialist.",
      },
      {
        q: "What brake controller do you recommend for a caravan?",
        a: "The REDARC Tow-Pro Elite. Proportional braking, hidden install, 5-year REDARC warranty. See our full brake controller buyer's guide for the reasoning.",
      },
      {
        q: "Do I need an Anderson plug on my tow vehicle for the caravan?",
        a: "If the caravan has a house battery you want charged on the drive — yes. A Grey Anderson plug wired through an ignition-controlled relay on the tow vehicle will charge the caravan's house battery while you drive, without risking the start battery.",
      },
      {
        q: "How long does a full caravan tow-vehicle setup take?",
        a: "One workshop day at Kunda Park for a full 12-pin + Tow-Pro + Anderson install. Individual services can be booked separately as half-day jobs.",
      },
      {
        q: "Which Sunshine Coast suburbs do you service?",
        a: "All of them. Workshop at 2a/3 Hitech Dr Kunda Park — for customers from Maroochydore, Mooloolaba, Caloundra, Noosa, Buderim, Sippy Downs, Coolum, Peregian and every Sunshine Coast suburb.",
      },
    ],
  },
];

export const SERVICE_PATH = (slug) => `/services/${slug}`;
export const findService = (slug) =>
  SERVICES.find((s) => s.slug === slug);

export { SUBURB_MENTIONS };
